import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addPhotos,
  deleteOneImage,
  getOneGalleryData,
} from "../../store/gallery/OneGallery/reducer";
import AdminNavbar from "../../components/partial/AdminNavbar";
import { updateGalleryData } from "../../store/gallery/reducer";
import FileUploader from "../../components/common/FileUploader";

const EditGallery = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const { title } = useParams();

  const dispatch = useDispatch();
  const OneGalleryData = useSelector(
    (state) => state.OneGalleryReducer.OneGalleryData
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [updatedTitle, setUpdatedTitle] = useState(title);
  const [updatedDescription, setUpdatedDescription] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    dispatch(getOneGalleryData(id));
  }, [dispatch, id]);

  const handleFilesUploaded = (files) => {
    setUploadedFiles([...files]);
  };

  const handleAddImage = () => {
    setImageModal(!imageModal);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    uploadedFiles.forEach((file) => {
      formData.append("photos", file);
    });
    try {
      dispatch(addPhotos(formData, id));
      closeAddModal();
      dispatch(getOneGalleryData(id));
    } catch (error) {
      console.error("Error submitting photos:", error);
    }
  };

  useEffect(() => {
    if (OneGalleryData) {
      setUpdatedTitle(OneGalleryData.title || title);
      setUpdatedDescription(OneGalleryData.description || "");
    }
  }, [OneGalleryData, title]);

  useEffect(() => {
    setIsUpdated(
      updatedTitle !== OneGalleryData?.title ||
        updatedDescription !== OneGalleryData?.description
    );
  }, [updatedTitle, updatedDescription, OneGalleryData]);

  const handleImageClick = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage("");
  };

  const closeAddModal = () => {
    setImageModal(false);
  };

  const handleDelete = (photo) => {
    if (window.confirm("Are you sure you want to delete this photo?")) {
      dispatch(deleteOneImage(id, photo)).then(() => {
        dispatch(getOneGalleryData(id));
      });
    }
  };

  const handleUpdate = () => {
    if (isUpdated) {
      const updatedGalleryData = {
        title: updatedTitle,
        description: updatedDescription,
      };
      dispatch(updateGalleryData(id, updatedGalleryData));
      navigate("/nvm-admin/gallery");
    }
  };

  if (!OneGalleryData || !OneGalleryData.photos) {
    return <div>Loading gallery data...</div>;
  }

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 md:justify-center">
      <div className="lg:w-1/6 md:w-1/3 ">
        {/* <AdminNavbar /> */}
      </div> 
      <div className="flex-1 p-6 md:flex-row md:px-12">
        <div className="h-64 w-full bg-gray-200 flex items-center justify-center rounded-lg shadow-lg mb-8">
          <span className="text-3xl font-semibold text-gray-700">{title}</span>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
          <input
            type="text"
            value={updatedTitle}
            onChange={(e) => setUpdatedTitle(e.target.value)}
            className="p-2 border border-gray-300 rounded-lg w-full sm:w-1/2 mb-4 sm:mb-0"
            placeholder="Edit Title"
          />
          <button
            className="bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition-all"
            onClick={handleAddImage}
          >
            Add Images
          </button>
        </div>

        <textarea
          value={updatedDescription}
          onChange={(e) => setUpdatedDescription(e.target.value)}
          className="p-2 border border-gray-300 rounded-lg w-full mb-6"
          placeholder="Edit Description"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {OneGalleryData.photos.map((photo, index) => (
            <div
              key={index}
              className="relative bg-white rounded-lg shadow-lg cursor-pointer"
            >
              <img
                src={`${photo}`}
                alt={updatedTitle}
                className="w-full h-48 object-cover rounded-t-lg"
                onClick={() => handleImageClick(photo)}
              />
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(photo);
                }}
                className="absolute top-2 right-2 bg-red-500 text-white rounded px-2 py-1"
              >
                Delete
              </button>
            </div>
          ))}
        </div>

        <button
          onClick={handleUpdate}
          disabled={!isUpdated}
          className={`${
            isUpdated ? "bg-blue-500" : "bg-gray-500"
          } text-white py-2 px-4 rounded-lg mt-6`}
        >
          Update
        </button>

        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          className="flex items-center justify-center p-4"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
        >
          <div className="bg-white rounded-lg p-6 max-w-lg mx-auto">
            <img
              src={`${currentImage}`}
              alt="Preview"
              className="w-full h-auto rounded-lg"
            />
            <button
              onClick={closeModal}
              className="mt-4 bg-gray-500 text-white px-4 py-2 rounded-lg"
            >
              Close
            </button>
          </div>
        </Modal>

        <Modal
          isOpen={imageModal}
          onRequestClose={closeAddModal}
          className="flex items-center justify-center p-4"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
        >
          <div className="bg-white rounded-lg p-6 max-w-lg mx-auto">
            <FileUploader onFilesUploaded={handleFilesUploaded} allowMultiple />
            <div className="flex justify-end mt-4">
              <button
                className="bg-green-500 text-white px-4 py-2 rounded-lg mr-2"
                onClick={handleSubmit}
              >
                Submit
              </button>
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded-lg"
                onClick={closeAddModal}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default EditGallery;
